<style>
  .mainDiv {
    width: 150px;
    border: 5px solid #000;
    background-color: #f00;
    margin: 10px;
    margin-top: 20px;
    float: right;
    text-align: center;
    padding: 10px;
    cursor: pointer;
  }

  .mainDiv p {
    color: #fff;
    font-weight: bolder;
  }

  .arrow {
    background: url(assets/Content/leftArraw.png);
    height: 100px;
    background-size: cover;
    text-align: center;
    background-repeat: round;
    float: right;
    width: 150px;
    cursor: pointer;
  }

  .arrow .arrowP {
    
    color: #fff;
    line-height: 100px;
    font-weight: bolder;
  }

  .subMoeinDiv {
    width: 350px;
    min-height: 150px;
    background: #fdfdf0;

    padding: 10px;
    visibility: hidden;

    border-radius: 5px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border: 0.1px solid #aaa5a5;
    position: relative;
  }



  .subMoeinDiv:hover {
    visibility: visible;
  }

  .subMoeinDiv img {
    width: 60px;
    height: 75px;
    float: right;
  }

  .subMoeinDiv .subMoeinDivDetail {
    float: right;
    direction: rtl;
    text-align: right;
    margin: 0px 10px 0 0;
  }

  .subMoeinDiv .subMoeinDsc {
    margin: 10px 0 10px 0;
    text-align: justify;
  }



  .arrow *:hover ~ .subMoeinDiv {
    visibility: visible;
  }
</style>

<div>
  <div class="mainDiv">
    <p>1) {{DataList_History_Main[0].sender}}</p>
  </div>




  <ng-container *ngFor="let item of DataList_History_Main">
    <div class="arrow">
      <p class="arrowP">{{item.semat_sender}}</p>


      <div class="subMoeinDiv">
        <img src="{{BaseUrl}}{{item.imageUser}}" />
        <div class="subMoeinDivDetail">
          <p> فرستند : {{item.sender}} ({{item.semat_sender}}) </p>
          <p> گیرنده : {{item.giver}} ({{item.semat_giver}}) </p>


        </div>
        <div style="clear:both"></div>
        <p class="subMoeinDsc"> توضیحات : {{item.dsc}} </p>
        <p style="text-align: right;"> زمان ارسال : {{item.persianDate}}</p>
        <p style="text-align: right;"> زمان مشاهده : {{item.visitDate}}</p>


        <p *ngIf="item.notes.length>0" class="subMoeinDsc"> یادداشت : </p>

        <ul *ngIf="item.notes.length>0">
          <li class="MyNote" *ngFor="let note of item.notes">{{note.message}} ({{note.fullname}} ,
            {{note.persianDate}})
          </li>
        </ul>

      </div>

    </div>

    <div class="mainDiv">
      <p>{{DataList_History_Main.indexOf(item)+2}}) {{item.giver}}</p>
    </div>

  </ng-container>




</div>